let gtmInitialized = false;

/**
 * Inject the Google Tag Manager container snippet.
 * GTM natively respects Consent Mode signals set via gtag('consent', ...).
 */
export function initGTM(containerId: string): void {
  if (gtmInitialized || !containerId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
  script.setAttribute('data-analytics', 'gtm');
  document.head.appendChild(script);

  gtmInitialized = true;
}
